export default "__VITE_ASSET__CB7g7OOj__"